<!-- Search Section -->
<div class="search-container">
  <div class="search-controls">
    <form [formGroup]="invoiceSearchForm" class="invoice-search-form">
      <!-- Search Field Selector -->
      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Search by</mat-label>
        <mat-select formControlName="searchField" [disabled]="isLoading">
          @for (option of searchFieldOptions; track option) {
            <mat-option [value]="option.value">
              {{ option.name | transloco }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <!-- Search Value Input -->
      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Search value</mat-label>
        <input matInput formControlName="searchValue" placeholder="Type search text" [disabled]="isLoading">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>

      <!-- Search Button -->
      <button mat-raised-button color="primary" (click)="applyInvoiceFilters()" [disabled]="isLoading"
        class="search-button">
        <mat-icon>search</mat-icon>
        {{ 'ORDER_LIST.APPLY_FILTERS' | transloco }}
      </button>

      <!-- Clear Button -->
      <button mat-stroked-button (click)="clearInvoiceFilters()" [disabled]="isLoading" class="clear-button">
        <mat-icon>clear</mat-icon>
        {{ 'ORDER_LIST.CLEAR_FILTERS' | transloco }}
      </button>
    </form>
  </div>
</div>

<!-- Filters Section -->
<div class="filters-container">
  <div class="filters-header">
    <div class="filters-title">
      <mat-icon>filter_list</mat-icon>
      <span>{{ 'ORDER_LIST.FILTERS' | transloco }}</span>
    </div>
  </div>

  <div class="filters-content">
    <div class="filter-group multiple-select">
      <label class="filter-label">{{ 'ORDER_LIST.STATUS' | transloco }}</label>
      <mat-form-field>
        <mat-select [placeholder]="'ORDER_LIST.STATUS' | transloco" [(value)]="selectedInvoiceStatuses" multiple
          (selectionChange)="onInvoiceStatusChange()" [disabled]="isLoading">
          @for (status of invoiceStatusOptions; track status) {
            <mat-option [value]="status.value">
              {{ status.name }}
            </mat-option>
          }
        </mat-select>
        @if (selectedInvoiceStatuses && selectedInvoiceStatuses.length > 0) {
          <mat-hint>
            {{ selectedInvoiceStatuses.length }} status(es) selected
          </mat-hint>
        }
      </mat-form-field>
    </div>
  </div>
</div>

<!-- Results Section -->
<div class="results-section">
  <mat-paginator #invoicePaginator [length]="totalInvoices" [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons
  [disabled]="isLoading"></mat-paginator>

  <div class="overflow-auto">
    <table mat-table matSort [dataSource]="invoiceDataSource" class="results-table mat-elevation-z2">

      <!-- Invoice Number Column -->
      <ng-container matColumnDef="invoiceNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'OPERATORS.INVOICE_NUMBER' | transloco }}</th>
        <td mat-cell *matCellDef="let invoice"> {{ invoice.invoiceNumber }} </td>
      </ng-container>

      <!-- Customer Number Column -->
      <ng-container matColumnDef="customerNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'OPERATORS.CUSTOMER_NUMBER' | transloco }}</th>
        <td mat-cell *matCellDef="let invoice"> {{ invoice.customerNumber }} </td>
      </ng-container>

      <!-- Order Number Column -->
      <ng-container matColumnDef="orderNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'OPERATORS.ORDER_NUMBER' | transloco }}</th>
        <td mat-cell *matCellDef="let invoice"> {{ invoice.orderNumber }} </td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'ORDER_LIST.STATUS' | transloco }}</th>
        <td mat-cell *matCellDef="let invoice"> {{ invoice.status }} </td>
      </ng-container>

      <!-- Amount Column -->
      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'OPERATORS.AMOUNT' | transloco }}</th>
        <td mat-cell *matCellDef="let invoice"> {{ invoice.amount }} SEK </td>
      </ng-container>

      <!-- Our Reference Column -->
      <ng-container matColumnDef="ourReference">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'OPERATORS.REFERENCE' | transloco }}</th>
        <td mat-cell *matCellDef="let invoice"> {{ invoice.ourReference }} </td>
      </ng-container>

      <!-- Email Column -->
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'ORDER_LIST.EMAIL' | transloco }}</th>
        <td mat-cell *matCellDef="let invoice"> {{ invoice.email }} </td>
      </ng-container>

      <!-- Created Date Column -->
      <ng-container matColumnDef="created">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'OPERATORS.CREATED_DATE' | transloco }}</th>
        <td mat-cell *matCellDef="let invoice"> {{ invoice.created | date:'yyyy-MM-dd HH:mm' }} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="invoiceDisplayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: invoiceDisplayedColumns;"></tr>

      <!-- Row shown when there is no matching data -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="invoiceDisplayedColumns.length">{{ 'ORDER_LIST.NO_DATA' | transloco
        }}</td>
      </tr>
    </table>
  </div>
</div>